import React, { useRef } from "react";
import Lottie from "lottie-react";
import state from '../../assets/images/loading.json';


type Props = {
  onClick: (event: any) => void;
  name: string;
  loading: boolean;
  isDisabled: boolean;
};


function NextButton({ onClick, name,loading, isDisabled }: Props) {
  const lottieRef = useRef<any>( null );
  return (
    <div>
      <button onClick={onClick} disabled={isDisabled} className="text-white text-xl bg-wallyBlue w-full flex rounded-full justify-center items-center mt-5 p-2 disabled:bg-slate-200 disabled:text-slate-500 disabled:border-slate-200">
              <div className="w-5/6  center">{name}</div>
              <div className="h-10 w-6/6">
                <Lottie className="lottieLoading"
                  animationData={state}
                  loop={true} 
                  lottieRef={lottieRef}
                  hidden={!loading}
                />
              </div>
            </button>
    </div>
  );
}

export default NextButton;